import { render } from "./NewsDetail.vue?vue&type=template&id=6b2cdb80"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Work/MANTEE_HOME/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__